import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'app-comment-container',
    templateUrl: './comment-container.component.html',
    styleUrls: ['./comment-container.component.scss'],
    standalone: false
})
export class CommentContainerComponent {

  @Input() commentText: string = '';
  @Input() readOnly: boolean = false;
  @Output() editContent = new EventEmitter<any>();
  @Output() deleteContent = new EventEmitter<any>();
  constructor() {
  }

  edit() {
    this.editContent.emit();
  }

  delete() {
    this.deleteContent.emit();
  }
}
